import { CommonModule } from '@angular/common';
import { Component, EventEmitter, input, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PoModule, PoWidgetModule } from '@po-ui/ng-components';
import { BarcodeFormat, BrowserMultiFormatReader } from '@zxing/library';
import { ZXingScannerModule } from '@zxing/ngx-scanner';

@Component({
  selector: 'app-scanner',
  standalone: true,
  imports: [PoModule, FormsModule, CommonModule, ZXingScannerModule, PoWidgetModule],
  templateUrl: './scanner.component.html',
  styleUrls: ['./scanner.component.css']
})
export class ScannerComponent implements OnInit, OnDestroy {
  @Input() itemPackOrigin: boolean = false;
  @Input() disabled: boolean = false;
  @Output() scannedData = new EventEmitter<string>();
  private codeReader: BrowserMultiFormatReader;

  barcodeValue: string = '';
  quantityValue: number = 1;
  activedScanner: boolean = false;
  scannedEffect: boolean = false;
  videoStream: MediaStream | null = null;
  formatsEnabled: BarcodeFormat[] = [BarcodeFormat.CODE_128, BarcodeFormat.EAN_13];
  scannedCodes: { code: string; format: string; timestamp: string }[] = [];
  isAndroid: boolean = false;

  constructor(
  ) {
    this.codeReader = new BrowserMultiFormatReader();
  }

  ngOnInit() {
    this.isAndroid = /Android/i.test(navigator.userAgent);
  }

  ngOnDestroy() {
    this.stopScan();
  }

  disableKeyboard() {
    const input = document.querySelector('input.po-input[name="inputBarcode"]') as HTMLInputElement;
    if (input) {
      input.setAttribute('readonly', 'true');
      setTimeout(() => {
        input.removeAttribute('readonly');
      }, 100);
    }
  }

  startScan() {
    this.activedScanner = true;
  }

  onInputClick() {
    const input = document.querySelector('input.po-input[name="inputBarcode"]') as HTMLInputElement;
    if (input) {
      input.setAttribute('inputmode', 'text');
    }
  }

  searchCode() {
    if (this.barcodeValue) {
      this.scannedData.emit(this.barcodeValue);
    }
    this.barcodeValue = '';
    this.resetInputMode();
  }

  private resetInputMode() {
    setTimeout(() => {
      const input = document.querySelector('input.po-input[name="inputBarcode"]') as HTMLInputElement;
      if (input) {
        input.setAttribute('inputmode', 'none');
        input.focus();
      }
    }, 100);
  }

  onCodeResult(result: string) {
    if (!result) return;

    let isValidEAN13 = /^\d{13}$/.test(result);
    let isValidCODE128 = /^[\x20-\x7E]+$/.test(result);

    if (isValidEAN13 || isValidCODE128) {
      this.scannedEffect = true;
      setTimeout(() => this.scannedEffect = false, 300);
      this.scannedData.emit(result);

      this.playBeep();
      this.resetInputMode();
    }
  }

  disableKeyboards() {
    const inputs = document.querySelectorAll('input');
    const inputElement = document.querySelector('input.po-input[name="inputBarcode"]') as HTMLInputElement;
    inputs.forEach(input => {
      input.addEventListener('focus', () => {
        setTimeout(() => {
          input.setAttribute('inputmode', '');
        }, 1);
      });
      input.addEventListener('blur', () => {
        input.setAttribute('inputmode', 'none');
      });
    });
    inputElement.focus();
    inputElement.blur();
    inputElement.focus();
  }

  stopScan() {
    this.activedScanner = false;
    if (this.videoStream) {
      const tracks = this.videoStream.getTracks();
      tracks.forEach(track => track.stop());
    }
    this.codeReader.reset();
  }

  playBeep() {
    const audioCtx = new (window.AudioContext || (window as any).webkitAudioContext)();
    const oscillator = audioCtx.createOscillator();
    oscillator.type = 'square';
    oscillator.frequency.setValueAtTime(440, audioCtx.currentTime);
    oscillator.connect(audioCtx.destination);
    oscillator.start();
    oscillator.stop(audioCtx.currentTime + 0.1);
  }
}
